/* Refreshes the free-delivery bar (snippets/bj-free-delivery.liquid) after any
   cart change, using the theme's own cart-update event. */
(function () {
  if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;

  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
    fetch(root + '?sections=bj-free-delivery')
      .then(function (response) { return response.json(); })
      .then(function (data) {
        const doc = new DOMParser().parseFromString(data['bj-free-delivery'] || '', 'text/html');
        const fresh = doc.querySelector('[data-bj-free-delivery]');
        if (!fresh) return;
        document.querySelectorAll('[data-bj-free-delivery]').forEach(function (el) {
          el.innerHTML = fresh.innerHTML;
        });
      })
      .catch(function () {});
  });
})();
